<template>
  <v-card class="mx-auto" :disabled="tbl_ldg">
    <v-card-title>
      <v-row dense>
        <v-col cols="12" md="8">
          <span class="text-h6 ml-1" v-text="$route.meta.title" />
        </v-col>
        <v-col cols="12" md="4" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab x-small class="ml-1" color="info" @click.stop="faqs_dlg = true" :loading="faqs_ldg"
                :disabled="faqs.length == 0">
                <v-icon>mdi-help</v-icon>
              </v-btn>
            </template>
            <span v-text="'Ayuda'" />
          </v-tooltip>

          <v-tooltip v-if="login.role_id == 1" bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab x-small class="ml-1" color="teal" :loading="btn_xls_ldg" :disabled="tbl.length == 0"
                @click.prevent="toXls">
                <v-icon>mdi-table-arrow-down</v-icon>
              </v-btn>
            </template>
            <span v-text="'Descargar tabla XLS'" />
          </v-tooltip>
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field v-model="txt" label="Buscar" type="text" dense maxlength="20" :disabled="tbl.length > 0" />
        </v-col>

        <v-col cols="12" md="3">
          <v-select v-model="find_insured" label="Asegurado o Folio" :items="find_insureds" item-value="id"
            :item-text="(v) => v.name" dense :disabled="tbl.length > 0" />
        </v-col>

        <v-col v-if="find_insured == 1" cols="12" md="3">
          <v-select v-model="type" label="Por" :items="types" item-value="id" :item-text="(v) => v.name" dense
            :disabled="tbl.length > 0" />
        </v-col>

        <v-col v-if="find_insured == 1" cols="12" md="3">
          <v-select v-model="for_rss" label="Para servicios" :items="for_rss_opt" item-value="id"
            :item-text="(v) => v.name" dense :disabled="tbl.length > 0" />
        </v-col>

        <v-col v-if="tbl.length == 0" cols="12">
          <v-btn block small color="info" @click.prevent="getTblData" :loading="tbl_ldg" :disabled="txt == ''">
            Buscar
            <v-icon right>mdi-magnify</v-icon>
          </v-btn>
        </v-col>

        <v-col v-else cols="12">
          <v-btn block small @click.prevent="
            tbl = [];
          insured = null;
          ">
            Cambiar parametros
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text v-if="tbl.length > 0">
      <v-row dense>
        <v-col cols="12">
          <v-card>
            <v-toolbar elevation="1" dense>
              <v-toolbar-title>
                <h2 class="text-caption" v-text="'ASEGURADO'" />
              </v-toolbar-title>
              <v-spacer />
              <v-toolbar-items />
            </v-toolbar>

            <v-divider />

            <v-card-text>
              <v-row v-if="insured" dense>
                <v-col cols="12" md="6">
                  <ViewData label="Nombre" :value="insured.full_name" />
                </v-col>
                <v-col cols="12" md="3">
                  <ViewData label="ID SM" :value="insured.enrollment" />
                </v-col>
                <v-col v-if="login.role_id == 1" cols="12" md="3">
                  <ViewData label="Núm. credencial" :value="insured.credential" />
                </v-col>
                <v-col cols="12" md="6">
                  <ViewData label="Contratante" :value="insured.contractor.name" />
                </v-col>
                <v-col cols="12" md="3">
                  <ViewData label="Oficina" :value="insured.office_address" />
                </v-col>
                <v-col cols="12" md="3">
                  <ViewData label="Vigencia" :value="insured.validity" />
                </v-col>
                <v-col cols="12" md="3">
                  <ViewData label="Tipo" :value="insured.insured_type.insured_type" />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="text-caption font-weight-bold" v-text="'Trat. méd'" />
                  <div>
                    <v-icon v-if="insured.medical_treatment" small>
                      mdi-close
                    </v-icon>
                    <v-icon v-else color="success" small>mdi-check</v-icon>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-card>
            <v-toolbar elevation="1" dense>
              <v-toolbar-title>
                <h2 class="text-caption" v-text="'RESULTADO'" />
              </v-toolbar-title>
              <v-spacer />
              <v-toolbar-items />
            </v-toolbar>

            <v-divider />

            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="9">
                  <ViewData label="Registros" :value="tbl.length" />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field v-model="tbl_search" append-icon="mdi-magnify" label="Buscar..." single-line
                    hide-details dense :disabled="tbl.length == 0" />
                </v-col>

                <v-col cols="12">
                  <v-data-table :headers="tbl_headers" :search="tbl_search" :items="tbl" :loading="tbl_ldg"
                    :items-per-page="15" dense :item-class="rowBg">
                    <template v-slot:item.index="{ index }">
                      <b v-text="index + 1" />
                    </template>

                    <template v-slot:item.folio="{ item }">
                      <div>
                        <span>{{ item.folio }}</span>

                        <v-tooltip v-if="item.rha_id && login.permissions.rhas.read" left>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" color="info" x-small icon :to="{
                              name: 'admission_request.detalle',
                              params: { id: item.rha_id },
                            }">
                              <v-icon small>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span v-text="'Detalle'" />
                        </v-tooltip>

                        <v-tooltip v-if="item.rs_id && login.permissions.rss.read" left>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" color="info" x-small icon :to="{
                              name: 'servicios.detalle',
                              params: { id: item.rs_id },
                            }">
                              <v-icon small>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span v-text="'Detalle'" />
                        </v-tooltip>
                      </div>
                    </template>

                    <template v-slot:item.insured.full_name="{ item }">
                      <span :class="item.insured.id ? '' : 'orange--text'">
                        {{ item.insured.full_name }}
                      </span>

                      <div v-if="
                        item.insured.full_name != item.insured.full_name_db
                      " class="pink--text">
                        <small>{{ item.insured.full_name_db }}</small>
                      </div>
                    </template>

                    <template v-slot:item.icd_txt="{ item }">
                      <span>{{ item.icd_txt }}</span>

                      <v-tooltip v-if="item.self_insurance_excess_icd" top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="warning" class="ml-1">
                            mdi-shield-check
                          </v-icon>
                        </template>
                        <span>
                          ICD registrado directamente en Exceso de Autoseguro
                        </span>
                      </v-tooltip>

                      <v-tooltip v-else-if="item.self_insurance_excess_icd_indirect" top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="info" class="ml-1">
                            mdi-link-variant
                          </v-icon>
                        </template>

                        <span>
                          ICD relacionado indirectamente con Exceso de
                          Autoseguro
                          <template v-if="item.rs_service_with_rha">
                            mediante RHA {{ item.rs_service_with_rha }}
                          </template>
                        </span>
                      </v-tooltip>

                      <v-tooltip v-if="
                        item.self_insurance_excess_icd_indirect &&
                        item.rs_service_with_rha &&
                        login.permissions.rhas.read
                      " top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" color="info" x-small icon :to="{
                            name: 'admission_request.detalle',
                            params: { id: item.rs_service_with_rha },
                          }">
                            <v-icon x-small>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>
                          Ver RHA relacionado {{ item.rs_service_with_rha }}
                        </span>
                      </v-tooltip>
                    </template>

                    <template v-slot:item.deducible_amount="{ item }">
                      {{
                        item.deducible_amount != null
                          ? numberFormat(item.deducible_amount)
                          : null
                      }}
                    </template>

                    <template v-slot:item.bill="{ item }">
                      <span :class="item.bill_active ? '' : 'red--text'">
                        {{ (item.bill_active ? "" : "*") + item.bill }}
                      </span>

                      <v-tooltip v-if="
                        item.rs_service_id &&
                        item.bill_id &&
                        login.permissions.rs_service_bills.read
                      " left>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" color="warning" x-small icon :to="{
                            name: 'facturacion_servicios.detalle',
                            params: { id: item.bill_id },
                          }">
                            <v-icon small>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span v-text="'Detalle'" />
                      </v-tooltip>

                      <v-tooltip v-if="
                        item.rha_id &&
                        item.bill_id &&
                        login.permissions.rha_bills.read
                      " left>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" color="warning" x-small icon :to="{
                            name: 'facturacion.finder',
                            params: { rha_bill_id: item.bill_id },
                          }">
                            <v-icon small>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span v-text="'Detalle'" />
                      </v-tooltip>
                    </template>

                    <template v-slot:item.amount="{ item }">
                      {{ item.amount ? numberFormat(item.amount) : null }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>

    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />
  </v-card>
</template>

<script>
import Axios from "axios";
import {
  URL_API,
  headersToken,
  msgAlert,
  base64ToArrayBuffer,
  dateTimeToFile,
} from "../../control";

import FaqDlg from "../../components/FaqDlg.vue";
import ViewData from "../../components/ViewData.vue";

export default {
  components: {
    FaqDlg,
    ViewData,
  },

  data() {
    return {
      login: this.$store.getters.getLogin,
      for_rss: 0,
      for_rss_opt: [
        {
          id: 1,
          name: "SOLO CON CARTAS",
        },
        {
          id: 0,
          name: "TODOS",
        },
      ],
      find_insured: 1,
      find_insureds: [
        {
          id: 1,
          name: "ASEGURADO",
        },
        {
          id: 0,
          name: "FOLIO",
        },
      ],
      type: 1,
      types: [
        {
          id: 1,
          name: "FOLIO",
        },
        {
          id: 2,
          name: "ID SM",
        },
        {
          id: 3,
          name: "NÚM. SINIESTRO",
        },
      ],
      txt: "",
      insured: null,
      tbl: [],
      tbl_ldg: false,
      tbl_search: "",
      tbl_headers: [
        {
          text: "#",
          value: "index",
          filterable: false,
          width: "60",
        },
        {
          text: "Folio",
          value: "folio",
          width: "150",
        },
        {
          text: "F. creación",
          value: "created_at",
        },
        {
          text: "ID SM",
          value: "insured.enrollment",
        },
        {
          text: "Asegurado",
          value: "insured.full_name",
        },
        {
          text: "Tipo",
          value: "insured.insured_type.insured_type",
        },
        {
          text: "Contratante",
          value: "contractor",
        },
        {
          text: "ICD / Exceso Autoseguro",
          value: "icd_txt",
        },
        {
          text: "Tipo",
          value: "type",
        },
        {
          text: "Núm. siniestro",
          value: "sinister_number",
        },
        {
          text: "T. Prov. | Espec.",
          value: "provider_type",
        },
        {
          text: "Proveedor | Médico",
          value: "provider_txt",
        },
        {
          text: "Padecimiento",
          value: "accident",
        },
        {
          text: "Siniestro",
          value: "initial",
        },
        {
          text: "Deducible",
          value: "deducible_amount",
        },
        {
          text: "Coaseguro %",
          value: "coinsurance",
        },
        {
          text: "Facturado",
          value: "bill",
          width: "130",
        },
        {
          text: "F. registro factura",
          value: "bill_created_at",
          width: "120",
        },
        {
          text: "Promesa pago P.",
          value: "bill_pay_date",
          width: "120",
        },
        {
          text: "A. registro",
          value: "bill_insurance_reception_date",
          width: "120",
        },
        {
          text: "A. F. Pago",
          value: "insurance_paid_date",
          width: "120",
        },
        {
          text: "F. Pago",
          value: "paid_date",
          width: "120",
        },
        {
          text: "Obs. admin",
          value: "bill_observation_detail",
        },
        {
          text: "Observación rechazo",
          value: "bill_observation",
        },
        {
          text: "F. carta",
          value: "letter_date",
        },
        {
          text: "Monto",
          value: "amount",
        },
      ],
      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,
      btn_xls_ldg: false,
    };
  },

  methods: {
    numberFormat(v) {
      return Number(parseFloat(v).toFixed(2)).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },

    getTblData() {
      this.tbl_ldg = true;
      this.tbl = [];
      this.insured = null;

      Axios.get(
        URL_API +
        "/finder/main" +
        "?find_insured=" +
        this.find_insured +
        "&for_rss=" +
        this.for_rss +
        "&type=" +
        this.type +
        "&txt=" +
        this.txt,
        headersToken(this.login.token),
      ).then((res) => {
        this.tbl = res.data.data.items;

        if (this.tbl.length > 0) {
          this.insured = res.data.data.insured;
        } else {
          this.$swal.fire(msgAlert("warning", "No se obtuvieron resultados"));
        }

        this.tbl_ldg = false;
      });
    },

    toXls() {
      this.btn_xls_ldg = true;

      Axios.post(
        URL_API + "/finder/main/xlsx",
        {
          items: this.tbl,
        },
        headersToken(this.login.token),
      ).then((rsp) => {
        if (rsp.data.success) {
          const blob = new Blob([base64ToArrayBuffer(rsp.data.data)], {
            type: "application/xlsx",
          });

          let downloadLink = document.createElement("a");
          downloadLink.setAttribute("target", "_blank");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download =
            "SM_restituciones_" + dateTimeToFile() + ".xlsx";
          downloadLink.click();

          this.btn_xls_ldg = false;
        } else {
          this.$swal.fire(msgAlert("error", "Error al generar archixo XLSX"));
        }

        this.btn_xls_ldg = false;
      });
    },

    rowBg: function (item) {
      let bg = "";

      if (!item.active) {
        bg = "red lighten-4";
      }

      return bg;
    },
  },

  mounted() {
    Axios.get(
      URL_API + "/faqs/faq_interfaces/" + this.$route.meta.title,
      headersToken(this.login.token),
    ).then((res) => {
      this.faqs = res.data.data;
      this.faqs_ldg = false;
    });
  },
};
</script>